import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import {
  vsComponentName as FormViewComponentName,
  FormViewController,
} from "../../../../records/forms/formView";
import {
  FormViewConfig,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../records/forms/formView/service";
import {
  LookupManagementConfig,
  LookupManagementService,
  vsComponentName as lookupManagementComponentName,
  vsServiceName as LookupManagementServiceName,
} from "../../components/lookupManagement";
import {
  GridConfiguration,
  vsComponentName as RecordGridViewComponentName,
} from "../../../../records/views/recordGridView";
import { GridSettingsService } from "../../../../records/grids/settings/gridSettingsService";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";

lookupManagementComponentConfig.$inject = ["$stateProvider"];
export function lookupManagementComponentConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.machines.lookups", {
      url: "/lookups",
      component: lookupManagementComponentName,
      resolve: {
        initialType: [
          "$stateParams",
          ($stateParams: StateParams) => $stateParams.type,
        ],
      },
    })
    .state("main.machines.lookups.detail", {
      abstract: true,
      url: "/:type",
      params: {
        type: undefined,
      },
      resolve: {
        lookupManagementConfig: [
          LookupManagementServiceName,
          "$stateParams",
          (
            lookupManagementService: LookupManagementService,
            $stateParams: StateParams
          ) => lookupManagementService.getLookupConfig($stateParams.type),
        ],
      },
    })
    .state("main.machines.lookups.detail.add", getLookupEditState(true))
    .state("main.machines.lookups.detail.edit", getLookupEditState(false))
    .state("main.machines.lookups.detail.grid", {
      url: "",
      component: RecordGridViewComponentName,
      resolve: {
        gridConfig: [
          LookupManagementServiceName,
          "$stateParams",
          (
            lookupManagementService: LookupManagementService,
            $stateParams: StateParams
          ) => {
            return lookupManagementService.getGridConfig($stateParams.type);
          },
        ],
        gridDataSource: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.gridDataSource,
        ],
        gridSettings: [
          "gridSettingsService",
          "$stateParams",
          (
            gridSettingsService: GridSettingsService,
            $stateParams: StateParams
          ) =>
            gridSettingsService.getGridSettings(
              Symbol("main.machines.lookups.grid." + $stateParams.type)
            ),
        ],
        columns: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.columns,
        ],
        defaultSort: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.defaultSort,
        ],
        nameSingular: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.nameSingular,
        ],
        namePlural: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.namePlural,
        ],
        showAddButton: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.showAddButton,
        ],
        showAddButtonPermission: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.showAddButtonPermission,
        ],
        onItemCommand: [
          "gridConfig",
          (gridConfig: GridConfiguration) => gridConfig.onItemCommand,
        ],
        onAddNew: [
          "$state",
          ($state: StateService) => () => {
            $state.go("^.add");
          },
        ],
      },
    });
}

function getLookupEditState(isAddState: boolean) {
  const url = isAddState ? "/add" : "/edit/:id";
  return {
    url,
    component: FormViewComponentName,
    resolve: {
      formViewConfig: [
        FormViewServiceName,
        "$stateParams",
        (formViewService: FormViewService, $stateParams: StateParams) =>
          formViewService.getFormViewConfig($stateParams.type),
      ],
      fields: [
        "formViewConfig",
        (formViewConfig: FormViewConfig) =>
          fieldHelpers.columnLayout(formViewConfig.fields, 4),
      ],
      model: [
        "$stateParams",
        "lookupManagementConfig",
        (
          $stateParams: StateParams,
          lookupManagementConfig: LookupManagementConfig
        ) => {
          const id = $stateParams.id;
          if (id === undefined) return undefined;
          return lookupManagementConfig.fetchFormModel(id);
        },
      ],
      title: [
        "lookupManagementConfig",
        (lookupManagementConfig: LookupManagementConfig) =>
          (isAddState ? "Add" : "Edit") +
          ` ${lookupManagementConfig.displayName}`,
      ],
      onSubmit: [
        "formViewConfig",
        "$state",
        "$stateParams",
        (
          formViewConfig: FormViewConfig,
          $state: StateService,
          $stateParams: StateParams
        ) => [
          "formViewController",
          "model",
          (formViewController: FormViewController, model: any) =>
            formViewConfig
              .submitForm({ formViewController, model })
              .then((r) => {
                $state.go("^.grid", {
                  type: $stateParams.type,
                });
              }),
        ],
      ],
      onCancel: [
        "$state",
        "$stateParams",
        ($state: StateService, $stateParams: StateParams) => [
          () => {
            $state.go("^.grid", { type: $stateParams.type });
          },
        ],
      ],
    },
  };
}

// function getTypeFromStateParams($stateParams: StateParams): string {
//   const type: string = $stateParams.type;
//   const firstSlashIndex = type.indexOf("/");

//   return firstSlashIndex > -1 ? type.substring(0, firstSlashIndex) : type;
// }
